module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0137.jpg?v=3cadd023";